import { createVNode as _createVNode, createTextVNode as _createTextVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelText as _vModelText, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6323e588")

_pushScopeId("data-v-6323e588")
const _hoisted_1 = {
  id: "booking-widget-anchor",
  class: "boxed-widget booking-widget margin-top-35"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", null, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-calendar-check-o " }),
  /*#__PURE__*/_createTextVNode(" Booking")
], -1)
const _hoisted_3 = { class: "row with-forms  margin-top-0" }
const _hoisted_4 = { class: "col-lg-12" }
const _hoisted_5 = { class: "col-lg-12" }
const _hoisted_6 = { class: "panel-dropdown-content padding-reset" }
const _hoisted_7 = { class: "panel-dropdown-scrollable" }
const _hoisted_8 = { class: "col-lg-12" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Guests ")
const _hoisted_10 = {
  class: "qtyTotal",
  name: "qtyTotal"
}
const _hoisted_11 = { class: "panel-dropdown-content" }
const _hoisted_12 = { class: "qtyButtons" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "qtyTitle" }, "Adults", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DatePicker = _resolveComponent("DatePicker")
  const _directive_click_outside = _resolveDirective("click-outside")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_DatePicker, {
          modelValue: _ctx.picked,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.picked = $event)),
          "min-date": _ctx.minDate
        }, {
          default: _withId(({ inputValue, inputEvents }) => [
            _createVNode("input", _mergeProps({ value: inputValue }, _toHandlers(inputEvents)), null, 16, ["value"])
          ]),
          _: 1
        }, 8, ["modelValue", "min-date"])
      ]),
      _createVNode("div", _hoisted_5, [
        _withDirectives(_createVNode("div", {
          class: ["panel-dropdown time-slots-dropdown", { active: _ctx.timeslotsExpanded }]
        }, [
          _createVNode("a", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showTimeslots && _ctx.showTimeslots(...args)))
          }, _toDisplayString(_ctx.pickedTimeslot === null ? 'Time Slots' : _ctx.time(_ctx.pickedTimeslot.startTime) + ' - ' + _ctx.time(_ctx.pickedTimeslot.endTime)), 1),
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.timeslots, (timeslot) => {
                return (_openBlock(), _createBlock("div", {
                  key: timeslot,
                  class: "time-slot"
                }, [
                  _createVNode("input", {
                    type: "radio",
                    name: "time-slot",
                    id: "{{ timeslot.id }}",
                    class: { picked: timeslot?.id === _ctx.pickedTimeslot?.id }
                  }, null, 2),
                  _createVNode("label", {
                    for: "{{ timeslot.id }}",
                    onClick: ($event: any) => (_ctx.pickTimeslot(timeslot))
                  }, [
                    _createVNode("strong", null, _toDisplayString(_ctx.time(timeslot.startTime)) + " - " + _toDisplayString(_ctx.time(timeslot.endTime)), 1),
                    _createVNode("span", null, "Type: " + _toDisplayString(timeslot.seatType), 1),
                    _createVNode("span", null, _toDisplayString(timeslot.availableSeats) + " seat(s) available", 1)
                  ], 8, ["onClick"])
                ]))
              }), 128))
            ])
          ])
        ], 2), [
          [_directive_click_outside, _ctx.closeTimeslots]
        ])
      ]),
      _createVNode("div", _hoisted_8, [
        _withDirectives(_createVNode("div", {
          class: ["panel-dropdown", { active: _ctx.guestsExpanded }]
        }, [
          _createVNode("a", {
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showGuests && _ctx.showGuests(...args)))
          }, [
            _hoisted_9,
            _createVNode("span", _hoisted_10, _toDisplayString(_ctx.guests), 1)
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode("div", {
                class: "qtyDec",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.decGuests && _ctx.decGuests(...args)))
              }),
              _withDirectives(_createVNode("input", {
                type: "text",
                name: "qtyInput",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.guests = $event))
              }, null, 512), [
                [_vModelText, _ctx.guests]
              ]),
              _createVNode("div", {
                class: "qtyInc",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.incGuests && _ctx.incGuests(...args)))
              })
            ])
          ])
        ], 2), [
          [_directive_click_outside, _ctx.closeGuests]
        ])
      ])
    ]),
    _createVNode("a", {
      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.book && _ctx.book(...args))),
      class: "button book-now fullwidth margin-top-5"
    }, "Request To Book")
  ]))
})